







































































































































































































import Vue from 'vue';
import { requiredIf, required, maxLength } from 'vuelidate/lib/validators';
import { zip } from '@/validations';

import {
  CloseFullscreenWrapper,
  LoadingMessage,
  FormValidation,
  OpenHelp,
  StateOptions,
  TriggerRefreshError,
} from '@/mixins';

import {
  FullscreenWrapper,
  FullscreenSuccess,
  FullscreenError,
  FullscreenLoading,
} from '@/components/fullscreen-wrapper-components';

import { ValidateAddress } from '@/components/validate-address-component';

import { api, MEMBER_API_SUB_URLS } from '@/api';
import InputMaskTypes from '@/directives/input-mask/input-mask-types';
import { ExtendMixins } from '@/services';
import { MemberPersonalInformationResponseModel } from '@/@types/member';

interface Data {
  validateAddressIsLoading: boolean;
  showNoMatches: boolean;
  loadingMessage: string;
  isSubmitLoading: boolean;
  showSubmitSuccessMessage: boolean;
  successMessage: string;
  showSubmitErrorMessage: boolean;
  errorMessage: string;
  confirmBeforeClose: boolean;
  token: string;
  formModel: any;
}

export default ExtendMixins(
  CloseFullscreenWrapper,
  FormValidation,
  OpenHelp,
  StateOptions,
  LoadingMessage,
  TriggerRefreshError,
).extend({
  name: 'UpdateAddress',
  props: {
    params: {
      type: Object as () => any,
      required: true,
    },
  },
  data(): Data {
    return {
      validateAddressIsLoading: false,
      showNoMatches: false,
      loadingMessage: this.$options.filters.t([
        'update-provider_text_loading-message_validating-address',
        'provider_text_loading-message_validating-address',
      ]),
      isSubmitLoading: false,
      showSubmitSuccessMessage: false,
      successMessage: this.params.successMessage,
      showSubmitErrorMessage: false,
      errorMessage: this.params.errorMessage,
      confirmBeforeClose: true,
      token: '',
      formModel: {},
    };
  },

  beforeMount() {
    this.formModel = JSON.parse(JSON.stringify(this.personalInformation));
    this.constructShowErrorModel('formModel');
    this.showErrorModel.token = false;
  },
  validations: {
    token: {
      required,
    },
    formModel: {
      isNonUSAddress: {},
      address: {
        addressLine1: {
          required: requiredIf(function(this: any): boolean {
            return !this.isNonUSAddress;
          }),
          maxLength: maxLength(32),
        },
        addressLine2: {
          maxLength: maxLength(32),
        },
        city: {
          required: requiredIf(function(this: any): boolean {
            return !this.isNonUSAddress;
          }),
          maxLength: maxLength(24),
        },
        state: {
          required: requiredIf(function(this: any): boolean {
            return !this.isNonUSAddress;
          }),
        },
        zipCode: {
          required: requiredIf(function(this: any): boolean {
            return !this.isNonUSAddress;
          }),
          zip,
        },
      },
      nonUSAddressLine1: {
        required: requiredIf(function(this: any): boolean {
          return this.isNonUSAddress;
        }),
        maxLength: maxLength(32),
      },
      nonUSAddressLine2: {
        maxLength: maxLength(32),
      },
      nonUSAddressLine3: {
        required: requiredIf(function(this: any): boolean {
          return this.isNonUSAddress;
        }),
        maxLength: maxLength(32),
      },
    },
  },
  computed: {
    personalInformation(): MemberPersonalInformationResponseModel {
      return this.$store.getters.personalInformation;
    },
    isNonUSAddress(): boolean {
      return this.formModel.isNonUSAddress;
    },

    // VALIDATIONS
    tokenErrors(): string[] {
      const formField = 'token';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'global_form-error_token_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
      ]);
    },
    addr1Errors(): string[] {
      const formField = 'formModel.address.addressLine1';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'update-address_form-error_addr-1_required',
            'global_form-error_address_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
        this.FormValidationMixin.validateField(
          formField,
          'update-address_form-error_addr-1_max-length',
          'maxLength',
          { key: 'maxLength', val: 'max' },
        ),
      ]);
    },
    addr2Errors(): string[] {
      const formField = 'formModel.address.addressLine2';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          'update-address_form-error_addr-2_max-length',
          'maxLength',
          { key: 'maxLength', val: 'max' },
        ),
      ]);
    },
    cityErrors(): string[] {
      const formField = 'formModel.address.city';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'update-address_form-error_city_required',
            'global_form-error_city-required',
            'global_fxorm-error_default_required',
          ],
          'required',
        ),
        this.FormValidationMixin.validateField(
          formField,
          'update-address_form-error_city_max-length',
          'maxLength',
          { key: 'maxLength', val: 'max' },
        ),
      ]);
    },
    stateErrors(): string[] {
      const formField = 'formModel.address.state';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'update-address_form-error_state_required',
            'global_form-error_state-required',
            'global_form-error_default_required',
          ],
          'required',
        ),
      ]);
    },
    zipErrors(): string[] {
      const formField = 'formModel.address.zipCode';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'update-address_form-error_zip_required',
            'global_form-error_zip-required',
            'global_form-error_default_required',
          ],
          'required',
        ),
        this.FormValidationMixin.validateField(
          formField,
          [
            'update-address-error_zip_invalid-format',
            'global_form-error_default_invalid-format',
          ],
          'zip',
        ),
      ]);
    },
    nonUSAddr1Errors(): string[] {
      const formField = 'formModel.nonUSAddressLine1';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'update-address_form-error_non-us-addr-1_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
        this.FormValidationMixin.validateField(
          formField,
          'update-address_form-error_non-us-addr-1_max-length',
          'maxLength',
          { key: 'maxLength', val: 'max' },
        ),
      ]);
    },
    nonUSAddr2Errors(): string[] {
      const formField = 'formModel.nonUSAddressLine2';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          'update-address_form-error_non-us-addr-2_max-length',
          'maxLength',
          { key: 'maxLength', val: 'max' },
        ),
      ]);
    },
    nonUSAddr3Errors(): string[] {
      const formField = 'formModel.nonUSAddressLine3';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'update-address_form-error_non-us-addr-3_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
        this.FormValidationMixin.validateField(
          formField,
          'update-address_form-error_non-us-addr-3_max-length',
          'maxLength',
          { key: 'maxLength', val: 'max' },
        ),
      ]);
    },
  },
  methods: {
    tryAgain(): void {
      if (this.errorMessage === this.params.errorMessageTokenInvalid) {
        // We need user to start over and request a new token
        this.closeFullscreenWrapper();
        return;
      }
      this.showSubmitErrorMessage = false;
      this.confirmBeforeClose = true;
      this.errorMessage = this.params.errorMessage;
      this.loadingMessage = this.$options.filters.t([
        'update-provider_text_loading-message_validating-address',
        'provider_text_loading-message_validating-address',
      ]);
    },
    validateAddress(): void {
      this.showNoMatches = false;

      if (!this.formModel.isNonUSAddress) {
        this.isSubmitLoading = true;
        this.validateAddressIsLoading = true;
      } else {
        this.loadingMessage = this.$options.filters.t(
          'personal-information_loading_updating-address',
        );
        this.isSubmitLoading = true;
        this.updateAddress(this.formModel.address);
      }
    },
    addressCancel(): void {
      this.isSubmitLoading = false;
      this.validateAddressIsLoading = false;
    },
    showNoMatchesText(): void {
      this.isSubmitLoading = false;
      this.validateAddressIsLoading = false;
      this.showNoMatches = true;
    },
    updateAddress(address): void {
      this.validateAddressIsLoading = false;

      if (address) {
        Object.assign(address, {
          zipCode: InputMaskTypes.zip.deconstruct(address.zipCode),
        });
        Object.assign(this.formModel.address, address);
      }

      if (!this.formModel.isNonUSAddress) {
        // Make sure isNonUSAddress isn't null/undefined from GET API
        this.formModel.isNonUSAddress = false;
        this.$nextTick(() => {
          this.changeLoadingMessage(
            (this.$refs.fullscreenLoadingComponent as any).$refs.loadingMessage,
            'loadingMessage',
            this.$options.filters.t(
              'personal-information_loading_updating-address',
            ),
          );
        });
      }

      api
        .put(
          `${MEMBER_API_SUB_URLS.members}/${
            this.$store.getters.user.memberId
          }/profiles/addresses`,
          {
            address,
            isNonUSAddress: this.formModel.isNonUSAddress,
            nonUSAddressLine1: this.formModel.nonUSAddressLine1,
            nonUSAddressLine2: this.formModel.nonUSAddressLine2,
            nonUSAddressLine3: this.formModel.nonUSAddressLine3,
          },
          {
            headers: {
              'x-token': this.token,
            },
          },
        )
        .then(() => {
          this.refreshPersonalInformation();

          // GTM Event - Update Address
          window.dataLayer.push({
            event: 'updateAddress',
          });
        })
        .catch((error) => {
          if (error.status === 403) {
            this.errorMessage = this.params.errorMessageTokenInvalid;
          }

          this.confirmBeforeClose = false;
          this.showSubmitErrorMessage = true;
          this.isSubmitLoading = false;
        });
    },

    refreshPersonalInformation(): void {
      this.$store
        .dispatch('getPersonalInformation')
        .then(() => {
          this.confirmBeforeClose = false;
          this.showSubmitSuccessMessage = true;
          this.isSubmitLoading = false;
        })
        .catch(() => {
          this.isSubmitLoading = false;
          this.triggerRefreshError({
            message: [
              'update-address_text_refresh-data-error-message',
              'global_connection-error',
            ],
          });
        });
    },

    closeModal(): void {
      // @ts-ignore
      this.validateAddressModal = false;
    },
  },
  components: {
    FullscreenWrapper,
    FullscreenSuccess,
    FullscreenError,
    FullscreenLoading,
    ValidateAddress,
  },
});
